import Call from '../Call';
import {objToQs} from '../Utils';

const BidderECost = {
    get(filters) {
        return Call(`bidderECost?${objToQs(filters)}`);
    },

    getCountry(filters) {
        return Call(`bidderECost/country?${objToQs(filters)}`);
    },
};

export default BidderECost;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderECost.js